<template>
  <div class="byStages">
    <!-- <mt-header fixed title="分期购">
      <mt-button @click="goback" slot="left" icon="back">返回</mt-button>
    </mt-header> -->
    <div class="bg">
      <div class="title">
        <div>为您推荐</div>
        <div>最适合的金融方案</div>
      </div>
      <div class="StagesBox">
        <h1>{{carBrandName}}{{carModelName}}</h1>
        <div class="table">
          <table border="1" width="100%">
            <thead>
              <tr>
                <th></th>
                <th>首付</th>
                <th>月供</th>
                <th>期数</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>付一成</td>
                <td class="color1">{{(price*0.1).toFixed(2)}}万</td>
                <td class="color1">{{parseInt(price*0.9*10000/36 + price*0.9*10000*0.0059)}}元</td>
                <td class="color1">36期</td>
              </tr>
              <tr>
                <td>付二成</td>
                <td class="color1">{{(price*0.2).toFixed(2)}}万</td>
                <td class="color1">{{parseInt(price*0.8*10000/36 + price*0.8*10000*0.0059)}}元</td>
                <td class="color1">36期</td>
              </tr>
              <tr>
                <td>付三成</td>
                <td class="color1">{{(price*0.3).toFixed(2)}}万</td>
                <td class="color1">{{parseInt(price*0.7*10000/36 + price*0.7*10000*0.0059)}}元</td>
                <td class="color1">36期</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="StagesBox">
        <h1>分期购四大优势</h1>
        <div class="Four">
          <div class="box">
            <div>
              <h2>低首付</h2>
              <span>超低购车价</span>
            </div>
            <div>
              <h2>低月供</h2>
              <span>轻松还款无压力</span>
            </div>
          </div>
          <div class="box">
            <div>
              <h2>低门槛</h2>
              <span>申请通过率高</span>
            </div>
            <div>
              <h2>审批快</h2>
              <span>流程简单审批快</span>
            </div>
          </div>
        </div>
      </div>
      <div class="remarks">
        <p>1.在购车顾问协助下提交身份证、驾驶证、借记卡等信息，最快60分钟即可查看审批结果</p>
        <br>
        <p>2.具体金融方案可能根据客户信用资质发生调整，请以最终金融方案为准</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Header } from "mint-ui";
import {
  API_GET,
  API_POST,
  getLocation,
  getToken,
  API_GET_TOKEN,
  GET_DICT
} from "@/apiConfig";
export default {
  name: "byStages",
  data() {
    return {
      carModelName: "",
      resData:"",
      carBrandName:"",
      price: this.$route.query.price
    };
  },
  mounted() {
    this.fetchData();
    // this.getDict()
    window.scroll(0, 0);
    this.GET_DICT = GET_DICT;
  },
  methods: {
    goback: function() {
      window.history.go(-1);
    },

    getDict: function() {
      //获取数据字典
      API_GET_TOKEN("/lianlianche-car/carEnumDictionary/list", {}).then(res => {
        if (res.status == 0) {
          this.resData = res.data;
        } else {
          message: res.msg;
        }
      });
    },

    fetchData: function() {
      let body = {
        carModelName: this.$route.params.carModelName,
        price: this.$route.query.price,
        resData: this.$route.params.resData,
        carBrandName: this.$route.params.carBrandName,
      };
      this.carModelName = body.carModelName;
      this.resData = body.resData;
      this.carBrandName = body.carBrandName
      console.log(body);
      if (body.carId != null) {
        this.loading = true;
        API_GET("/lianlianche-car/car/share/detail", body).then(res => {
          if (res.status == 0) {
            this.resData = res.data;
          } else {
            Toast({
              message: res.msg
            });
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
  color: #2c2c2c;
}
.byStages {
  width: 100%;
  background-color: #f5f5f5;
}
.byStages .bg {
  width: 100%;
  background-image: linear-gradient(
    to bottom right,
    rgba(0, 215, 255, 1),
    rgba(0, 155, 255, 1)
  );
  height: 17.5rem;
}
.byStages .bg .title {
  width: 93.6%;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  color: #ffffff;
  padding-top: 2rem;
}

.byStages .bg .title div:first-child {
  font-size: 1.5rem;
  font-weight: 500;
}

.byStages .bg .title div:last-child {
  font-size: 1.8rem;
  font-weight: 500;
  padding-top: 0.5rem;
}

.byStages .bg .StagesBox {
  width: 93.6%;
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff;
  margin-top: 1.5rem;
  box-shadow: 0 0 3px #e1e1e1;
}
.byStages .bg .StagesBox h1 {
  font-size: 1.6rem;
  color: #2c2c2c;
  font-weight: 500;
  border-bottom: 1px solid #e1e1e1;
  padding-top: 1.6rem;
  padding-bottom: 1.6rem;
  line-height: 2.5rem;
}
.byStages .bg .StagesBox .table {
  padding: 1.5rem;
}
.byStages .bg .StagesBox .table table {
  border: none;
}
.byStages .bg .StagesBox .table th,
.byStages .bg .StagesBox .table td {
  font-size: 1.4rem;
  color: #757575;
  font-weight: 400;
  padding: 1rem 0;
  border-color: #a3a3a3;
}

.byStages .bg .StagesBox .Four {
  margin: 0 1.5rem;
  padding: 1.5rem 0 0.1rem 0;
}
.byStages .bg .StagesBox .Four .box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  margin-bottom: 1.5rem;
}

.byStages .bg .StagesBox .Four .box div {
  padding: 1.5rem;
  background-color: #f5f5f5;
  width: 12.2rem;
}

.byStages .bg .StagesBox .Four .box h2 {
  color: #4c4c4c;
  font-weight: 600;
  font-size: 1.5rem;
}

.byStages .bg .StagesBox .Four .box span {
  font-size: 1.4rem;
  color: #4c4c4c;
  padding-top: 0.5rem;
  display: inline-block;
}
.color1 {
  color: #ff4444 !important;
}

.byStages .remarks {
  width: 93.6%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  text-align: left;
  padding-bottom: 1.5rem;
  color: #757575;
}
</style>



// WEBPACK FOOTER //
// src/components/byStages.vue